export default "__VITE_ASSET__0V5WtW8f__"